export default __webpack_public_path__ + "media/images/app-icon-0d4bf47f4d5ce732b4b3c6573f7325f6.svg";